import { FC } from "react";

export const Notice: FC = () => {
  return (
    <div id="notice" className="notice">
      <div className="notice_in">
        <div className="title">
          <div className="title_t">活動辦法</div>
          <div className="title_bg"><img src="/resources/html/images/title_bg.png" /></div>
        </div>
        <ul className="notice_ul">
          <li className="notice_li">
            <span className="notice_titletext">活動期間：</span>自2021年6月16日起至8月11日止。
          </li>
          <li className="notice_li">
            <span className="notice_titletext">活動參加方式：</span>凡購買貼有活動貼紙之罐裝爽啤 330ml 單罐、6 入裝(活動版) 或 500ml 單罐，於活動期間內撕開貼紙掃描 QRcode 完成登錄即可參加抽獎。
          </li>
          <li className="notice_li">
            <span className="notice_titletext">活動獎項：</span><br />
            <p className="notice_ptext">(1)爽爽好禮即掃即抽【爽啤x油頭二世】限量獨家好禮</p>
          -【爽啤X油頭二世】不銹鋼爽勁杯(380ml)，共150名<br />
          -【爽啤X油頭二世】不銹鋼爽呼呼杯(510ml)，共150名<br />
          -【爽啤X油頭二世】悠閒舒爽野餐墊(146*168cm)，共200名<br />
          -【爽啤X油頭二世】沁涼爽勁冰桶(12.5L ; 附2款防水貼紙各1張)，共50名<br />
          -【爽啤X油頭二世】爽走天下行李箱(20吋; 黑/白顏色隨機 ; 附2款防水貼紙各1張)，共50名
            <p className="notice_ptext">(2)最爽好禮週週抽【時尚生活X享樂人生】大禮</p>
          - PlayStation 5  Digital Edition 遊戲主機，共2名<br />
          - Nintendo Switch 藍紅主機，共2名<br />
          - Apple 2020 iPad 8 平板電腦(10.2吋/Wi-Fi/32G/顏色隨機)，共2名<br />
          - MARSHALL ACTON II 藍牙喇叭(顏色隨機)，共2名
          </li>
          <li className="notice_li">
            <span className="notice_titletext">抽獎方式：</span>
            <ul className="notice_sul">
              <li>
                <span className="notice_ptext">爽爽好禮即掃即抽：</span>
              凡購買貼有活動貼紙之罐裝爽啤330ml單罐、6入裝(活動版) 或500ml單罐，於活動期間內撕開貼紙掃描QRcode完成登錄立即抽【爽啤x油頭二世】限量獨家好禮。
              </li>
              <li>
                <span className="notice_ptext">最爽好禮週週抽：</span>
              活動期間每週於沒有中獎之已登錄QR Code中抽出【時尚生活X享樂人生】大禮。
              </li>
            </ul>
          </li>
          <li className="notice_li">
            <span className="notice_titletext">中獎公告：</span>
            <ul className="notice_sul">
              <li>
                <span className="notice_ptext">爽爽好禮即掃即抽：</span>活動期間每天00:00於活動網站公告前一天的中獎名單。
              </li>
              <li>
                <span className="notice_ptext">最爽好禮週週抽：</span>活動期間每週五於活動網站公告中獎名單：<br />
                2021年6月25日公告：PlayStation 5 Digital Edition 遊戲主機<br />
                2021年7月02日公告：Nintendo Switch 藍紅主機<br />
                2021年7月09日公告：Apple 2020 iPad 8 平板電腦(10.2吋/Wi-Fi/32G/顏色隨機)<br />
                2021年7月16日公告：MARSHALL ACTON II 藍牙喇叭(顏色隨機)<br />
                2021年7月23日公告：PlayStation 5 Digital Edition 遊戲主機<br />
                2021年7月30日公告：Nintendo Switch 藍紅主機<br />
                2021年8月06日公告：Apple 2020 iPad 8 平板電腦(10.2吋/Wi-Fi/32G/顏色隨機)<br />
                2021年8月13日公告：MARSHALL ACTON II 藍牙喇叭(顏色隨機)
              </li>
            </ul>
          </li>
          <li className="notice_li">
            <span className="notice_titletext">活動相關疑問請洽詢【我的暢快爽勁】活動小組，聯絡方式：</span><br />
          電話：<a href="tel:+886-2-82583858 ">02-82583858</a><br />
          電子信箱：<a href="mailto:twsongbeer@jk2u.com.tw ">twsongbeer@jk2u.com.tw</a><br />
          (服務時間週一～週五10：00～18：30，不含例假日。)
          </li>
          <li className="notice_li">
            <span className="notice_titletext">兌獎方式：</span>中獎後系統會自動發送中獎確認函到填寫電子信箱，填寫完整後可選下列任一種方式寄回：<br />
            <ul className="notice_sul">
              <li>
              紙本郵件掛號寄回中獎確認函至新北市板橋區雙十路二段223號5樓「我的暢快爽勁活動小組收」。
              </li>
              <li>
              掃描中獎確認函電子檔以電子郵件寄至<a href="mailto:twsongbeer@jk2u.com.tw ">twsongbeer@jk2u.com.tw</a>。
              </li>
              <li>
              將中獎確認函傳真至<a href="tel:+886-2-82583858 ">02-82583858</a>。
              </li>
              <li>
              兌獎截止日期：2021 年8月20日止(紙本以郵戳為憑)。
              </li>
            </ul>
          </li>
          <li className="notice_li">
            <p className="notice_titletext">贈品得獎規範：</p>
            <ul className="notice_sul">
              <li>
              「中獎確認函」會自動寄送至中獎人留存之電子郵件信箱，須自行下載、列印並填妥後，於2021年 8月20日前將中獎確認函(內含同意書) 以掛號郵寄、掃描電子檔Email、傳真等方式擇一，提供至「我的暢快爽勁」活動小組，方可完成兌獎手續（以郵戳/傳送時間為憑），逾期視同自動放棄權利。
              </li>
              <li>
              中獎獎項單價價值累計新台幣1,001～20,001元者，依所得稅法規定需申報收入，請兌獎者／中獎者須將中獎確認函（附上身分證正反面影本）填妥後於2021年 8月20日前以掛號郵寄、掃描Email或傳真等方式擇一，提供至「我的暢快爽勁」活動小組，方可完成領獎手續（以郵戳/傳送時間為憑），逾期視同自動放棄權利。
              </li>
              <li>
              若活動小組在2021年8月20日前無法成功聯繫得獎者，將視同得獎者放棄中獎資格，活動小組則不再另行通知，且不再遞補中獎者。
              </li>
              <li>
              所有獎項統一於2021年8月23日後陸續寄出。
              </li>
            </ul>
          </li>
        </ul>
        <div className="title">
          <div className="title_t">活動注意事項</div>
          <div className="title_bg"><img src="/resources/html/images/title_bg.png" /></div>
        </div>
        <ul className="notice_sul">
          <li>
          本次活動主辦單位為臺灣菸酒股份有限公司，委由吉爾集思數位行銷有限公司「我的暢快爽勁活動小組」執行本次活動。參加活動者一旦參加本活動，則表示同意接受本辦法之拘束。
          </li>
          <li>
          本活動限有活動貼紙的罐裝330ml、500ml爽啤，購買前請認明罐身貼有黃色貼紙才可參加活動，各通路配貨數量有限，售完為止。
          </li>
          <li>
          參加活動者須年滿18歲；得獎者若未滿20歲，除得獎者之身分證正反面影本外，需另附法定代理人之身分證正反面影本協同辦理領獎及一切相關手續方能領獎。
          </li>
          <li>
          兌獎資料逾期繳交、資料不符或不齊全者，均視同放棄得獎權利。
          </li>
          <li>
          中獎確認函上所填寫之身分資料需和參加本活動之資料相同，如有不同，主辦單位有權取消其參加或得獎資格，並恕不另行通知。
          </li>
          <li>
          參加活動者同意活動期間內，所有留存或產生之任何參與活動的資料及記錄，皆以主辦單位的電腦系統與時間的記錄為主。如有任何因電腦、網路、電話、技術或不可歸責於主辦單位之事由，而使參加者送出之資料有延遲、遺失、錯誤、無法辨識之情況，主辦單位不負責任何法律責任，參加活動者不得因此異議。
          </li>
          <li>
          本活動屬競技競賽及機會中獎所得，依所得稅法之規定，年度累積中獎價值若超過新台幣1,000元整，應列入得獎人年度綜合所得，主辦單位依所得稅法第94-1條之規定，得免填發各類所得扣繳暨免扣繳憑單予得獎人，若得獎人有需求時請另行提出申請。得獎者若非中華民國國境內設籍之國人(即在中華民國境內居住未達 183 天之本國人及外國人)不論中獎者所得之金額，須就中獎所得扣繳 20% 機會中獎稅。若得獎者不願先行繳納本項稅金，視同放棄中獎資格，且不得異議。得獎者同意依台灣相關稅法規定繳納稅捐，並同意主辦單位得依相關法令代扣(繳納)相關稅捐。
          </li>
          <li>
          參加活動者應保證所有填寫或提出之資料，均為真實且正確，並未冒用或盜用他人資料，如有不實或不正確資訊，主辦單位將取消其獲獎資格，並就其損害主辦單位或任何第三人權益，保留一切民、刑事訴追之責。
          </li>
          <li>
          以任何駭客或其它非法行為破壞活動規則者，兌獎或中獎皆無效，主辦單位並對其參加者或得獎者保留法律追訴權。
          </li>
          <li>
          本活動之所有獎項不得轉讓或折換現金。
          </li>
          <li>
          贈品圖片僅供示意參考，實際規格以獎項的文字說明及注意事項說明為主，恕不挑選顏色。獎項以公佈於本網站上的資料為準，如遇不可抗力之因素，主辦單位保留修改活動與獎項細節的權利，無須事前通知，並有權對本活動所有事宜作出解釋或裁決。如本活動因不可抗力之特殊原因無法執行時，主辦單位有權決定取消、終止、修改或暫停本活動，如有任何未盡事宜，均以主辦單位依中華民國法律解釋之。
          </li>
          <li>
          獎品寄送地區僅限為台灣、澎湖、金門、馬祖地區，主辦單位恕不處理郵寄獎項至海外地區之事宜。
          </li>
          <li>
          本活動網頁之所有內容由主辦單位擁有所有著作權，未經許可，不得抄襲、拷貝與複製相關圖片與文字，主辦單位保留所有侵權事宜之法律追訴權利。
          </li>
          <li>
          參加活動者參與本活動時，視為同意接受本活動所有內容及細則之規範；倘有違反本活動相關注意規範，主辦單位得取消其獲獎資格，並對於任何破壞本活動之行為保留法律追訴權。
          </li>
          <li>
          主辦單位僅使用參加者所提供之個人資料於此次活動用途，且遵守【個人資料保護法】相關規定，以維護參加者權益。參加活動者同意中獎相關個人資訊由主辦單位及執行廠商於活動範圍內進行蒐集、電腦處理及利用，但不做其他用途，成功兌換商品者或得獎者授權主辦單位及執行廠商公開公佈姓名。
          </li>
          <li>
          活動相關疑問請洽詢活動小組專線：<br />
          聯絡電話：<a href="tel:+886-2-82583858 ">02-82583858</a><br />
          聯絡信箱：<a href="mailto:twsongbeer@jk2u.com.tw ">twsongbeer@jk2u.com.tw</a><br />
          (服務時間週一～週五10：00～18：30，不含例假日。)
          </li>
        </ul>
        <div className="title">
          <div className="title_t">個資法同意事項</div>
          <div className="title_bg"><img src="/resources/html/images/title_bg.png" /></div>
        </div>
        <ul className="notice_ul">
          <li className="notice_li">
          以下為履行個人資料保護法告知事項：<br />
          (一)依據個人資料保護法（以下稱個資法）規定，向參與本活動消費者告知下列事項，請參與本活動消費者於參與本活動前務必詳閱。<br />
            <ul className="notice_sul">
              <li>
              蒐集個人資料公司：臺灣菸酒股份有限公司、本活動執行廠商吉爾集思數位行銷有限公司（以下合稱本公司）
              </li>
              <li>
              蒐集之目的：辦理消費者活動。
              </li>
              <li>
              個人資料之類別：包括姓名、身分證統一編號、聯絡方式等個人資料中之識別類（具體項目則如本活動參與頁面及活動辦法內所列事項）。
              </li>
              <li>
              個人資料利用之期間、地區、對象及方式：<br />
              (1)期間：個人資料蒐集之特定目的存續期間、依相關法令或契約約定之保存期限，或本公司為執行業務或前述蒐集之目的所必需之保存期間。<br />
              (2)地區：本國、未受中央目的事業主管機關限制之國際傳輸個人資料之接收者所在地。<br />
              (3)對象：本公司、本公司委託機關及執行本活動時之必要相關人員。<br />
              (4)方式 ：以自動化機器或其他非自動化之利用方式。
              </li>
            </ul>
          (二)依據個資法第三條規定，本活動參與者了解，就其所提供之個人資料得行使下列權利
            <ul className="notice_sul">
              <li>
              得向本公司查詢或請求閱覽、請求製給複製本，惟本公司依法得酌收必要成本費用。
              </li>
              <li>
              得向本公司請求補充或更正，惟依法本活動參與者應為適當之釋明。
              </li>
              <li>
              得向本公司請求停止蒐集、處理或利用以及請求刪除，惟依法本公司因執行職務所必須者，得不依本活動參與者請求為之。
              </li>
            </ul>
          (三)不提供個人資料所致權益之影響：
            <ul className="notice_ssul">
              <li>本活動參與者可自由選擇是否提供本公司其個人資料，若拒絕提供相關個人資料，經檢舉或本公司發現不足以確認本活動參與者的身分真實性或其他個人資料冒用、盜用、資料不實等情形，致本公司無法進行必要之確認作業，本公司有權暫時停止或中/終止提供本活動相關服務，若有不便之處敬請見諒。</li>
            </ul>
            活動參加者瞭解本公司上開告知事項，並已清楚瞭解本公司蒐集、處理及利用活動參加者個人資料之目的及用途，並同意本公司於上開告知事項範圍內，得蒐集、處理、國際傳遞及利用活動參加者資料。<br />
            活動參加者在依本活動辦法之活動參加方式參與活動時，即表示您已充分閱讀、瞭解並同意遵守上述個資法告知事項，並同意將個人資料提供本次活動參與必要範圍之用途。
          </li>
        </ul>
      </div>
    </div>
  );
};
